import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { readingTime, formatDate } from "@/data/articles";

export const ArticleCard = ({ article, testid }) => (
    <Link
        to={`/riflessioni/${article.slug}`}
        data-testid={testid}
        className="group flex flex-col h-full rounded-3xl bg-white border border-ink/5 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500 overflow-hidden"
    >
        {article.image ? (
            <div className="aspect-[4/5] overflow-hidden bg-sand">
                <img
                    src={article.image}
                    alt={article.imageAlt}
                    loading="lazy"
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
                />
            </div>
        ) : (
            <div className="aspect-[4/5] bg-sage-light flex items-center justify-center p-8">
                <span className="font-serif italic text-2xl text-sage-dark/60 text-center leading-snug">Riflessioni</span>
            </div>
        )}
        <div className="flex flex-col flex-1 p-7">
            <span className="self-start rounded-full bg-petrol-light text-petrol text-xs font-semibold px-3.5 py-1.5">
                {article.category}
            </span>
            <h3 className="mt-4 font-serif text-xl sm:text-2xl font-semibold text-ink leading-snug group-hover:text-petrol transition-colors duration-300">
                {article.title}
            </h3>
            <p className="mt-auto pt-5 flex items-center gap-2 text-xs text-[#7A8C8E]">
                <Clock size={13} />
                {formatDate(article.date)} · {readingTime(article)} min di lettura
            </p>
        </div>
    </Link>
);
